export default __webpack_public_path__ + "static/media/rswhite.f167035b.png";